import { serviceMaker, methods, api } from "@/http/index.js";


export const getPropertyList = () =>
  serviceMaker(`/property`, methods.GET, api.NGB);
export const getPropertyTemplate = () =>
  serviceMaker(`/property/template`, methods.GET, api.NGB);
export const createProperty = (data) =>
    serviceMaker(`/property`, methods.POST, api.NGB, data);
export const editProperty = (id, data) =>
    serviceMaker(`/property/${id}`, methods.PUT, api.NGB, data);
export const viewProperty = (id) =>
    serviceMaker(`/property/${id}`, methods.GET, api.NGB);
export const deleteProperty = (id) =>
    serviceMaker(`/property/${id}`, methods.DELETE, api.NGB);
export const getPropertyMasterList = () =>
    serviceMaker(`/propertymaster`, methods.GET, api.NGB);
export const getPropertyMasterTemplate = () =>
    serviceMaker(`/propertymaster/template`, methods.GET, api.NGB);
export const createPropertyMaster = (data) =>
    serviceMaker(`/propertymaster`, methods.POST, api.NGB, data);
export const editPropertyMaster = (id, data) =>
    serviceMaker(`/propertymaster/${id}`, methods.PUT, api.NGB, data);
export const viewPropertyMaster = (id) =>
    serviceMaker(`/propertymaster/${id}`, methods.GET, api.NGB);
export const deletePropertyMaster = (id) =>
    serviceMaker(`/propertymaster/${id}`, methods.DELETE, api.NGB);
